import { LoggedInUserService } from '../../core/services/loggedInUser/logged-in-user.service';
import { Injectable } from '@angular/core';

export interface Theme {
  mainColor?: any;
  secundaryColor?: any;
  id?: any;
  label?: string;
  name?: string;
  className?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ThemeConfigurationService {
  loggedInUser: any = null;
  public selectedTheme: Theme = null;

  ListThemes: Theme[] = [
    {
      mainColor: '#1565c0',
      secundaryColor: '#f44336',
      id: 0,
      label: 'blueTheme',
      name: 'Blue',
      className: 'blueThemeClass',
    },
    {
      mainColor: '#222222',
      secundaryColor: '#f44336',
      id: 1,
      label: 'darkTheme',
      name: 'Dark',
      className: 'darkThemeClass',
    },
  ];

  constructor(private loggedInUserService: LoggedInUserService) {
    // this.loggedInUser = this.loggedInUserService.getLoggedInUser();
    // if (this.loggedInUser) {
    //   const itemId = this.loggedInUser.Agency && this.loggedInUser.Agency.themeColor ? this.loggedInUser.Agency.themeColor : 0;
    //   if (!itemId) {
    //     this.selectedTheme = this.ListThemes[0];
    //   } else {
    //     this.selectedTheme = this.ListThemes[itemId - 1];
    //   }
    // } else {
    //   this.selectedTheme = this.ListThemes[0];
    // }

    this.selectedTheme = this.selectedTheme ? this.selectedTheme : this.ListThemes[0];
    document.getElementById('bodyAppId').className = this.selectedTheme.className;
  }

  public getArrayThemes(): Theme[] {
    return this.ListThemes;
  }
}
